import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import CarServices from '../services/CarServices';
import useAsync from '../hooks/useAsync';
import ViewService from './View Model/ViewService';
import TogalButtonForStatus from './TogelButton/TogalButtonForStatus';
import TogalButtonForTrending from './TogelButton/TogalButtonForTrending';
import Modal from 'react-modal';
import DeleteButton from './Button/DeleteButton';
import ServiceUpdate from './Update Model/UpdateService';
import ReactPaginate from 'react-paginate';
import * as XLSX from 'xlsx';
import Swal from "sweetalert2";

Modal.setAppElement('#root');

function ShopPending() {
  const { data, error, isLoading, run } = useAsync(CarServices.getServicePending);
  const [currentPage, setCurrentPage] = useState(1);
  const [activeIndex, setActiveIndex] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedEdit, setSelectedEdit] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedService, setSelectedService] = useState(null);

  const servicePerPage = 10; // Number of items per page

  const handleRequestChange = async (status, service) => {
    try {

      const body = {
        approval_status: status
      };

      const res = await CarServices.updateApprovalStatus(service._id, body);

      if (res.data.status) {

        Swal.fire({
          icon: "success",
          title: "Success",
          text: `Service request ${status} successfully`,
          timer: 1500,
          showConfirmButton: false
        });

        run(); // table refresh

      } else {

        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Something went wrong"
        });

      }

    } catch (error) {

      Swal.fire({
        icon: "error",
        title: "Server Error",
        text: "Failed to update status"
      });

      console.log(error);
    }
  };

  const handleViewDetails = (service) => {
    setSelectedService(service);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedService(null);
  };

  const handleEditDetails = (service) => {
    setSelectedEdit(service);
    setIsEditModalOpen(true);
    toggleActionMenu(null);
  };

  const handleDelete = (service) => {
    setSelectedEdit(service);
    setIsDeleteModalOpen(true);
    toggleActionMenu(null);
  };

  const closeEditModal = () => {
    setIsEditModalOpen(false);
    setSelectedEdit(null);
  };

  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false);
    setSelectedEdit(null);
  };

  const toggleActionMenu = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  const handlePageClick = (data) => {
    setCurrentPage(data.selected + 1); // ReactPaginate's `selected` is zero-based
  };

  const formatDateTime = (isoString) => {
    const date = new Date(isoString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  // Filter services based on search query
  const filteredServices = data?.data?.filter((service) =>
    service.title.toLowerCase().includes(searchQuery.toLowerCase().trim())
  ) || [];

  // Paginate filtered data
  const indexOfLastService = currentPage * servicePerPage;
  const indexOfFirstService = indexOfLastService - servicePerPage;
  const paginatedServices = filteredServices.slice(indexOfFirstService, indexOfLastService);

  const generateExcel = () => {
    const filteredData = filteredServices.map((service) => ({
      title: service.category.title,
      title: service.subCategory.title,
      title: service.title,
      description: service.description,
      date: formatDateTime(service.createdAt),
      status: service.status,
    }));

    const ws = XLSX.utils.json_to_sheet(filteredData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'serviceData');
    XLSX.writeFile(wb, 'service_data.xlsx');
  };

  function truncateText(text, limit) {
    const words = text.split(' ');
    if (words.length > limit) {
      return words.slice(0, limit).join(' ') + '...';
    }
    return text;
  }

  return (
    <>
      <div className="right_col" role="main">
        <div className="d-md-flex  align-items-center justify-content-between my-4 page-header-breadcrumb">

          <div className="my-auto">

            <h5 className="page-title fs-21 mb-1">
              Shop Pending List <span className="badge bg-orange">{filteredServices.length}</span>
            </h5>
            <nav>

              <ol className="breadcrumb mb-0">

                <li className="breadcrumb-item">
                  <a href="javascript:void(0);">Home</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Pending
                </li>
              </ol>
            </nav>
          </div>
          <div className="d-flex my-xl-auto gap-2 right-content align-items-center">


            <Link className="round-add-btn" to="/add-shop">
              <img src="img/plus.svg" alt="Add Shop" />
            </Link>
            {/* <button className="excel-btn" onClick={generateExcel}>
              <img src="img/excel.svg" alt="Download Excel" />
              Download
            </button> */}

          </div>
        </div>

        <div className="container-box px-0 pt-2">
          <div className="Tablesearch_design">
            <div className="row">
              <div className='col-md-6 col-6  '>
                <div className='d-flex align-items-center justify-content-between gap-2'>
                  <input
                    type="search"
                    name="search"
                    placeholder="Search"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    className='form-control'
                  />
                  <button className="search-btn">Search</button>
                </div>
              </div>
              <div className='col-md-6 col-6  '>

              </div>
            </div>

          </div>

          <div className="container-box-inner table-reponsive-tabe">
            <table id="example" className="table table-striped" style={{ width: '100%' }}>
              <thead>
                <tr>
                  <th>#</th>
                  <th>CATEGORY NAME</th>
                  {/* <th>SUB CATEGORY NAME</th> */}
                  <th>TITLE</th>
                  <th>DESCRIPTION</th>
                  <th>DATE</th>
                  {/* <th>TRENDING STATUS</th> */}
                  <th>REQUEST</th>
                  <th>STATUS</th>
                  <th>ACTION</th>
                </tr>
              </thead>
              <tbody>
                {paginatedServices.length > 0 ? (
                  paginatedServices.map((service, i) => (
                    <tr key={i}>
                      <td>{i + 1 + indexOfFirstService}</td>
                     <td>{service.category?.title || 'N/A'}</td>
                      <td>{service.title}</td>
                      <td>{truncateText(service.description, 5)}</td>
                      <td>{formatDateTime(service.createdAt)}</td>

                      <td>
                        <div className="custom-dropdown">
                          <select
                            className={`status-select ${(service.approval_status || "Pending").toLowerCase()}`}
                            value={service.approval_status || "Pending"}
                            onChange={(e) => handleRequestChange(e.target.value, service)}
                          >
                            <option value="Pending">⏳ Pending</option>
                            <option value="Approve">✅ Approve</option>
                            <option value="Reject">❌ Reject</option>
                          </select>
                        </div>
                      </td>

                      <td className="status-toggle">
                        <TogalButtonForStatus data={service} page="service" onSuccess={run} />
                      </td>

                      <td>
                        <div className="action_toggle_outer">
                          <button className="action_toggle" onClick={() => toggleActionMenu(i)}>
                            <i className="fa fa-ellipsis-v" />
                          </button>

                          {activeIndex === i && (
                            <div className="action_toggle_content product-edit show d-block">
                              <ul className="list-unstyled">
                                <li>
                                  <button className="close_toggle" onClick={() => toggleActionMenu(null)}>
                                    <i className="fa fa-close" />
                                  </button>
                                </li>
                                <li>
                                  <button className="edit" onClick={() => handleEditDetails(service)}>Edit</button>
                                </li>
                                <li>
                                  <button className="reject" onClick={() => handleDelete(service)}>Delete</button>
                                </li>
                                <li>
                                  <button className="approve" style={{ backgroundColor: '#263238' }} onClick={() => handleViewDetails(service)}>View</button>
                                </li>
                              </ul>
                            </div>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="8" style={{ textAlign: "center", fontWeight: "bold" }}>
                      No Data Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <div className="pagination">
            <ReactPaginate
              pageCount={Math.ceil(filteredServices.length / servicePerPage)}
              pageRangeDisplayed={3}
              marginPagesDisplayed={1}
              onPageChange={handlePageClick}
              containerClassName={'pagination'}
              activeClassName={'active'}
              previousLabel={'Previous'}
              nextLabel={'Next'}
              breakLabel={'...'}
              breakClassName={'break-me'}
              pageLinkClassName={'page-link'}
              previousLinkClassName={'page-link'}
              nextLinkClassName={'page-link'}
              pageClassName={'page-item'}
              previousClassName={'page-item'}
              nextClassName={'page-item'}
              disabledClassName={'disabled'}
            />
          </div>
        </div>
        <Modal
          isOpen={isEditModalOpen}
          onRequestClose={closeEditModal}
          contentLabel="Edit Service"
          className="modal-content"
          overlayClassName="modal-overlay"
        >
          <ServiceUpdate service={selectedEdit} closeModal={closeEditModal} onSuccess={run} />
        </Modal>
        <Modal
          isOpen={isDeleteModalOpen}
          onRequestClose={closeDeleteModal}
          contentLabel="Delete Confirmation"
          className="modal-content"
          overlayClassName="modal-overlay"
        >
          <DeleteButton data={selectedEdit} page="Service" closeModal={closeDeleteModal} onSuccess={run} />
        </Modal>
        <Modal
          isOpen={isModalOpen}
          onRequestClose={closeModal}
          contentLabel="View Service"
          className="modal-content"
          overlayClassName="modal-overlay"
        >
          <ViewService service={selectedService} closeModal={closeModal} />
        </Modal>
      </div>
    </>
  );
}

export default ShopPending;
